import axios from 'axios'
import { AgreementBUInterface, BusinessUnitInterface } from '../interfaces'
import { ListResponse } from '../interfaces/Shipment/ListResponseDto'
import { getBusinessUnitsInnovus } from './BusinessUnitServices'
import { resolveOriginBusinessUnits } from '../utils/originBusinessUnits'

const { REACT_APP_URL_PATH_API } = process.env

export const getAgreementBU = async (
  agreementID?: string
): Promise<ListResponse<AgreementBUInterface[]>> => {
  const uri = `${REACT_APP_URL_PATH_API}/Agreement/AgreementBU?AgreementID=${
    agreementID ?? ''
  }`
  const response = await axios
    .get(uri)
    .then((response) => response.data as ListResponse<AgreementBUInterface[]>)
    .catch((error) => {
      console.error('getAgreementBU error', error?.message ?? error)
      return {
        model: [],
        didError: true,
        message: '',
        errorMessage: error?.message ?? '',
      } as ListResponse<AgreementBUInterface[]>
    })

  return response
}

// Resuelve las oficinas ORIGEN usables de un contrato. Usa getBusinessUnitsInnovus
// en AMBOS caminos (login y cambio de cliente) para que los matches por buCode sean
// idénticos (refinamiento #4).
//
// Las tiendas DESTINO salen del MISMO endpoint pero por otro camino: el hook
// `useContractDestinationBUs` lee las filas crudas y `resolveDestinationBusinessUnits`
// aplica la regla. No se resuelven acá porque necesitan el conjunto completo de
// filas (origen incluido) para decidir si el contrato restringe.
export const getOriginBusinessUnits = async (
  agreementID?: string
): Promise<BusinessUnitInterface[]> => {
  if (!agreementID) return []

  const [agreementRes, businessUnits] = await Promise.all([
    getAgreementBU(agreementID),
    getBusinessUnitsInnovus(),
  ])

  if (agreementRes.didError || !agreementRes.model) return []

  return resolveOriginBusinessUnits(agreementRes.model, businessUnits ?? [])
}
